<template>
  <div
    id="meeting-details"
    :class="[
      !isShelves ? 'safe-distance-bottom-tool' : '',
      $route.query.out ? 'safe-distance-top-header' : 'safe-distance-top',
    ]"
  >
    <!-- 取消会议详情页顶部H5端打开APP头部 ----------- -->
    <!-- <detail-header
      :pageTitle="articleMeeting.title"
      :shareInfo="shareInfo"
    ></detail-header> -->
    <Header v-if="$route.query.out" :pageTitle="articleMeeting.title">
      <template #right>
        <img
          class="search-icon"
          src="@/assets/img/mobile-img/search.png"
          @click="toSearch"
        />
        <van-icon name="ellipsis" @click="rightBut" />
      </template>
    </Header>
    <!-- 取消会议详情页顶部H5端打开APP头部 ----------- -->
    <Shelves v-if="isShelves" />
    <div v-else>
      <!-- 页面滚动之后出现顶部导航   -->
      <anchor-scroll-nav
        v-if="tabsTitle.length > 1"
        :class="{
          'has-top': !$route.query.out,
        }"
        :tabsTitleList="tabsTitle"
        anchorFlag=".anchor-box"
        faBoxId="meeting-details"
      ></anchor-scroll-nav>
      <!-- 1.顶部图片 100%宽 -->
      <div class="top-img">
        <img :src="$global.imgUrl + articleMeeting.cover" alt="" />
      </div>
      <!-- 2.主体内容 区域，统一设置边距-->
      <div class="content">
        <!-- 2.1会议基本信息（名称时间等） -->
        <div class="content-box meeting-info">
          <!-- 价格 -->
          <span v-show="showPriceInfo" class="price"
            >¥
            <span v-html="goodsMinPrice"></span>
            <span
              v-show="maxPrice && minPrice !== maxPrice"
              v-html="goodsMaxPrice"
            ></span>
          </span>
          <!-- 标题 -->
          <h3 class="title" v-html="articleMeeting.title"></h3>
          <!-- 时间 -->
          <p class="time">
            <img :src="require('@/assets/img/details/shijian.png')" alt="" />
            <span>
              <span v-show="articleMeeting.beginTime" v-html="beginTime"></span>
              <span v-show="articleMeeting.endTime" v-html="endTime"></span>
            </span>
          </p>
          <!-- 位置  meetingType:1 显示线上会议，2为线下会议显示地址-->
          <p class="address">
            <span v-if="articleMeeting.meetingType == 1">线上会议</span>
            <template v-else>
              <img
                :src="require('@/assets/img/details/biaojididian.png')"
                alt=""
              />
              <span v-html="fullAddress"></span>
            </template>
          </p>
        </div>
        <div
          v-if="tabsTitle.length > 1"
          ref="tabsBoxRef"
          class="content-box tabs-box"
        >
          <div
            class="tabs-item"
            v-for="(item, index) in tabsTitle"
            :key="index"
          >
            <div :class="index | tabsBgImgFilter" @click="goAnchor(index)">
              {{ item.anchorName }}
            </div>
          </div>
        </div>
        <!-- 2.1.1 主办承办协办单位  9-04暂时隐藏，随下版本增加其他单位显示-->
        <div v-if="false" class="content-box meeting-units">
          <div v-if="primaryOrgnizerList.length">
            <h1>主办单位</h1>
            <p
              v-for="item in primaryOrgnizerList"
              :key="item.id"
              v-html="item.name"
              @click="
                $router.push({
                  path: '/appusesinstitutions',
                  query: { type: item.type, orgId: item.orgId },
                })
              "
            ></p>
          </div>
          <div v-if="undertakerList.length">
            <h1>承办单位</h1>
            <p
              v-for="item in undertakerList"
              :key="item.id"
              v-html="item.name"
              @click="
                $router.push({
                  path: '/appusesinstitutions',
                  query: { type: item.type, orgId: item.orgId },
                })
              "
            ></p>
          </div>
          <div v-if="coOrganizerList.length">
            <h1>协办单位</h1>
            <p
              v-for="item in coOrganizerList"
              :key="item.id"
              v-html="item.name"
              @click="
                $router.push({
                  path: '/appusesinstitutions',
                  query: { type: item.type, orgId: item.orgId },
                })
              "
            ></p>
          </div>
        </div>
        <!-- 2.2 会议详情 富文本回显-->
        <div
          class="content-box detail-info anchor-box"
          name="详情"
          v-if="content.articleContent"
        >
          <h1>会议详情</h1>
          <div class="detail-info-box" v-html="content.articleContent"></div>
        </div>
        <!-- 2.3 征稿信息  征稿详情为必填项-->
        <div
          v-if="articleMeeting.isSubmit"
          class="content-box call-for-papers anchor-box"
          name="征稿信息"
        >
          <h1>征稿信息</h1>
          <div>
            <div class="papers-edit">
              <div v-if="edits.length">
                <h3>征稿采编</h3>
                <!-- 采编名片：点击可跳转采编名片H5详情 -->
                <div>
                  <div
                    class="edit-infos"
                    v-for="(edit, ind) in edits"
                    :key="ind"
                  >
                    <div @click.stop="toEditCard(edit.userId, edit.perId)">
                      <h2>
                        <p v-html="edit.perName"></p>
                        <img
                          :src="require('@/assets/img/details/arrow-right.png')"
                          alt=""
                        />
                      </h2>
                      <div class="edit-contact-info">
                        <!-- 期刊封面 -->
                        <img :src="$global.imgUrl + edit.perImg" alt="" />
                        <h4>
                          <span class="edit-name" v-html="edit.userName"></span>
                          <span
                            class="edit-title"
                            v-html="edit.editType == 1 ? '采编' : '组稿人'"
                          ></span>
                        </h4>
                        <p v-html="edit.phone"></p>
                        <p v-html="edit.website"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="periodicals.length" class="cooperative-journal">
                <h3>合作期刊</h3>
                <div class="cooperative-journal-name">
                  <div
                    v-for="(peridical, ind) in periodicals"
                    :key="ind"
                    @click="handleToBk(peridical)"
                  >
                    <img
                      v-if="peridical.perImg"
                      :src="$global.imgUrl + peridical.perImg"
                      alt=""
                    />
                    <img v-else src="@/assets/img/mobile-img/zz_default.png" />
                    <span v-html="peridical.perName"></span>
                  </div>
                </div>
              </div>
              <div
                v-if="articleMeeting.editBeginTime"
                class="solicitation-date"
              >
                <label>征稿日期</label>
                <span
                  v-show="articleMeeting.editEndTime"
                  v-html="editEndTime"
                ></span>
              </div>
              <!-- 征稿主题为富文本回显  -->
              <!-- <div class="solicitation-theme">
                <h3>征稿主题</h3>
                <div
                  class="solicit-content"
                  style="overflow: hidden"
                  v-html="articleMeeting.solicitContent"
                ></div>
              </div> -->
            </div>
          </div>
        </div>
        <!-- 2.9 会议论文 -->
        <div
          v-if="paperList.length"
          class="content-box proceedingsList-info anchor-box"
          name="会议论文"
        >
          <div class="titleBox">
            <h1>会议论文</h1>
            <div class="genduo" @click="tocollectedPapers">
              更多
              <van-icon name="arrow" />
            </div>
          </div>
          <div
            class="proceedingsList-item"
            v-for="item in paperList"
            :key="item.articleId"
            @click="goConferencePaperDetails(item.articleId)"
          >
            <div class="title" v-html="item.title"></div>
            <div class="author">{{ item.author }}</div>
          </div>
        </div>
        <!-- 2.4 组委会信息 -->
        <div
          class="content-box committee-info anchor-box"
          name="组委会"
          v-if="committees.length"
        >
          <h1>组委会</h1>
          <div>
            <!-- 循环组委会成员信息： 点击可跳转至对应学者百家号 -->
            <ul>
              <li
                class="committee-member"
                v-for="committee in committees"
                :key="committee.id"
                @click="scholarDetail(committee.userId)"
              >
                <div class="member-basic-info">
                  <img
                    :src="$global.imgUrl + committee.headImg"
                    alt=""
                    class="personal-img"
                  />
                  <div>
                    <p>
                      <span
                        class="member-name"
                        v-html="committee.userName"
                      ></span>
                      <!-- 成员title多个 levelTwo:自定义职称-->
                      <label
                        v-for="title in committee.titles"
                        :key="title.id"
                        class="member-title"
                        v-html="title.levelTwo"
                        v-show="title.levelTwo"
                      ></label>
                    </p>
                    <!-- 任职机构-现任职位-->
                    <p class="member-education-info">
                      {{ committee.orgName }}
                      <span v-show="committee.orgName && committee.position">
                        -
                      </span>
                      {{ committee.position }}
                    </p>
                  </div>
                </div>
                <!-- 学者简介 -->
                <div class="member-intro" v-html="committee.profile"></div>
              </li>
            </ul>
          </div>
          <!-- <div v-else class="empty-data">
            <img
              class="zanwu-img"
              src="@/assets/img//mobile-img/zanwu.png"
              alt=""
            />
            <p class="zanwu-text">暂无组委会信息</p>
          </div> -->
        </div>
        <!-- 2.5 会议资料 -->
        <div
          class="content-box conference-proceedings anchor-box"
          name="资料"
          v-if="fileList.length"
        >
          <h1>会议资料</h1>
          <div>
            <!-- 循环资料列表，点击能下载 @click -->
            <ul>
              <li
                v-for="resource in fileList"
                :key="resource.id"
                @click="downloadFile(resource.url, resource.fileName)"
              >
                <!-- <a href="javascript:;" @click="downMeetingResource(resource.url)">{{
              resource.fileName
            }}</a> -->
                {{ resource.fileName }}
              </li>
            </ul>
          </div>
          <!-- <div v-else class="empty-data">
            <img
              class="zanwu-img"
              src="@/assets/img//mobile-img/zanwu.png"
              alt=""
            />
            <p class="zanwu-text">暂无会议资料</p>
          </div> -->
        </div>
        <!-- 2.6 会议相册 -->
        <div
          class="content-box album anchor-box"
          name="相册"
          v-if="imgVideoList.length"
        >
          <h1>会议相册</h1>
          <div>
            <!-- 会议相册横向滑动 点击可查看/播放图片、视频 type 1 图片 2 视频 -->
            <ul class="album-container">
              <li
                class="album-item"
                v-for="album in imgVideoList"
                :key="album.id"
              >
                <img
                  v-if="album.type == 1"
                  :src="$global.imgUrl + album.url"
                  alt="album.name"
                />
                <video
                  v-else
                  :src="$global.imgUrl + album.url"
                  controls
                ></video>
              </li>
            </ul>
          </div>
          <!-- <div v-else class="empty-data">
            <img
              class="zanwu-img"
              src="@/assets/img//mobile-img/zanwu.png"
              alt=""
            />
            <p class="zanwu-text">暂无相册</p>
          </div> -->
        </div>
        <!-- 自定义详情内容 -->
        <template v-if="contentList && contentList.length">
          <div
            v-for="item in contentList"
            :key="item.id"
            class="content-box detail-info anchor-box"
            :name="item.contentFlag"
          >
            <div v-if="content.articleContent">
              <h1>{{ item.contentFlag }}</h1>
              <div class="detail-info-box" v-html="item.articleContent"></div>
            </div>
          </div>
        </template>
        <!-- 2.7 金融研修学院链接  isHided 0未隐藏 1已隐藏-->
        <div v-if="!business.isHided" class="content-box college-of-finance">
          <img
            :src="
              business.headImg
                ? $global.imgUrl + business.headImg
                : require('@/assets/mylogin/default-JG.png')
            "
            alt=""
          />
          <div class="businessName" v-html="business.name"></div>
          <button @click="jump">查看</button>
        </div>
        <!-- 2.8 相关会议 :当前发布人的其他会议 v-if="otherMeetingList.length" 暂时不需要 -->
        <div v-if="false" class="content-box related-meetings">
          <h1>相关会议</h1>
          <div
            v-for="relatedMeeting in otherMeetingList"
            :key="relatedMeeting.id"
            class="related-meeting-card"
          >
            <img :src="$global.imgUrl + relatedMeeting.cover" alt="" />
            <h2
              v-show="relatedMeeting.title"
              v-html="relatedMeeting.title"
            ></h2>
            <p>
              <span v-html="relatedMeeting.address"></span>
              <span>{{
                relatedMeetingTime(
                  relatedMeeting.beginTime,
                  relatedMeeting.endTime
                )
              }}</span>
            </p>
          </div>
        </div>
      </div>
      <!-- 3.底部分享收藏点击报名 -->
      <footer-toolbar
        title="会议"
        :shareInfo="shareInfo"
        @sharePoster="sharePoster"
      >
        <!-- 分享面板右侧按钮 -->
        <template
          #right
          v-if="$route.query.goodsId && $route.query.open == '1'"
        >
          <van-button
            type="info"
            plain
            :round="true"
            @click="contributeShow = true"
          >
            论文投稿
          </van-button>
          <template v-if="isPay">
            <div v-if="isOnline || meetingStatus !== 'REGISTER_START'">
              <div
                class="continue_box"
                v-if="meetingStatus === 'REGISTER_START'"
              >
                <span>您已报名,可继续报名</span>
                <van-button
                  type="info"
                  plain
                  :round="true"
                  @click="meetingSignup"
                >
                  继续报名
                </van-button>
              </div>
              <van-button type="info" :round="true" @click="handleWatch">
                进入会议
              </van-button>
            </div>
            <van-button v-else type="info" :round="true" @click="meetingSignup">
              继续报名
            </van-button>
          </template>
          <template v-else>
            <van-button v-if="isSale === 1" color="#dddddd" :round="true">
              已停售
            </van-button>
            <van-button
              v-else-if="meetingStatus === 'REGISTER_START'"
              type="info"
              :round="true"
              @click="meetingSignup"
            >
              立即报名
            </van-button>
            <van-button v-else color="#dddddd" :round="true">{{
              meetingStatus | meetingStatusFilter
            }}</van-button>
          </template>
        </template>
      </footer-toolbar>
      <!-- 4.sku面板 -->
      <goods-sku
        v-if="showSku"
        goodsType="meeting"
        :showSku="showSku"
        :sku="sku"
        :goods="goods"
        :initial-sku="initialSku"
        buyText="立即报名"
        @handleBuy="handleSignup"
        @updateSkuPannelStatus="updateSkuPannelStatus"
      ></goods-sku>
      <ExtendTool
        :hasExtend="hasExtend"
        :shareInfo="shareInfo"
        @sharePoster="(showStatus) => sharePoster(showStatus, true)"
      />
      <!-- 生成海报及海报分享 遮罩 -->
      <van-overlay
        class="poster-overlay"
        :lock-scroll="true"
        :show="showPoster"
        @click="restorePageScroll"
        @touchmove.prevent
        @mousewheel.prevent
      >
        <div class="wrapper">
          <div
            class="meeting-course"
            style="
              width: 100vw;
              height: 100vh;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
            "
          >
            <img
              id="poster"
              v-if="posterUrl"
              width="315"
              height="356"
              ref="poster"
              :src="posterUrl"
              alt=""
              crossOrigin="anonymous"
            />
          </div>
        </div>

        <div
          class="poster-html"
          v-show="showPoster"
          style="opacity: 0; pointer-events: none"
        >
          <!-- 会议和课程海报 v-if="title == '会议' || title == '课程'"-->
          <div id="poster-dom" class="poster-meeting-course">
            <div class="poster-content">
              <img
                class="cover"
                :src="$global.imgUrl + articleMeeting.cover"
                alt=""
              />

              <h1 class="title" v-html="tempTitle"></h1>
              <h2 class="price" v-show="showPriceInfo">
                <span class="price"
                  >¥
                  <span v-html="goodsMinPrice"></span>
                  <span
                    v-show="maxPrice && minPrice !== maxPrice"
                    v-html="goodsMaxPrice"
                  ></span>
                </span>
              </h2>
            </div>

            <div class="poster-bottom">
              <div class="qr-code-area">
                <div ref="qrcode" id="qrcode"></div>
                <span>长按识别二维码</span>
              </div>
              <img
                src="@/assets/img/mobile-img/zw-logo.png"
                alt=""
                class="logo"
              />
            </div>
          </div>
        </div>
      </van-overlay>
      <van-popup v-model="contributeShow" round :close-on-click-overlay="false">
        <div class="contribute_box">
          <h3>暂不支持手机投稿，去网页投稿</h3>
          <p>1. 用电脑访问</p>
          <p>{{ contributeUrl }}</p>
          <p>2. 使用手机/账号登录后即可开始投稿</p>
          <van-button
            type="default"
            plain
            :round="true"
            @click="contributeShow = false"
          >
            知道了
          </van-button>
          <van-button type="info" :round="true" @click="toContribute">
            复制链接
          </van-button>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { Icon, Toast } from "vant";
import FooterToolbar from "@/views/mobileView/detail/components/bottomTool.vue";
import AnchorScrollNav from "@/views/mobileView/detail/components/anchorScrollNav.vue";
import GoodsSku from "@/views/mobileView/detail/components/goodsSku.vue";
import ExtendTool from "@/views/mobileView/detail/components/extendTool.vue";
import Shelves from "@/views/mobileView/detail/components/shelves.vue";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import Header from "@/views/mobileView/components/header";

export default {
  name: "MeetingDetails",
  components: {
    "van-icon": Icon,
    Header,
    FooterToolbar,
    ExtendTool,
    AnchorScrollNav,
    GoodsSku,
    Shelves,
  },
  data() {
    return {
      tabsTitleTem: [
        {
          anchorName: "详情",
          active: true,
          // 必填
          show: false,
        },
        {
          anchorName: "征稿信息",
          active: false,
          // 根据有无内容决定是否显示
          show: false,
        },
        {
          anchorName: "会议论文",
          active: false,
          // 根据有无内容决定是否显示
          show: false,
        },
        {
          anchorName: "组委会",
          active: false,
          show: false,
        },
        {
          anchorName: "资料",
          active: false,
          show: false,
        },
        {
          anchorName: "相册",
          active: false,
          show: false,
        },
      ],
      tabsTitle: [],
      showSku: false,
      /* vant sku 数据格式 --start */
      sku: {
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
        tree: [
          // {
          //   k: "票种", // skuKeyName：规格类目名称
          //   k_s: "s1", // skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
          //   v: [
          //     {
          //       id: "1", // skuValueId：规格值 id
          //       name: "免费票", // skuValueName：规格值名称
          //       // imgUrl: require("@/assets/img/details/bkqktg.png"), // 规格类目图片，只有第一个规格类目可以定义图片
          //       // previewImgUrl: require("@/assets/img/details/bkqktg.png"), // 用于预览显示的规格类目图片
          //     },
          //   ],
          // },
        ],
        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [
          /* 示例数据
          {
            id: 1, // skuId
            s1: "1", // 规格类目 k_s 为 s1 的对应规格值 id
            s2: "1", // 规格类目 k_s 为 s2 的对应规格值 id
            price: 110, // 价格（单位分）
            stock_num: 110, // 当前 sku 组合对应的库存
            desc: "组合110商品描述",
          },
          */
        ],
        price: "", // 默认价格（单位元）
        stock_num: null, // 商品总库存
        collection_id: null, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: false, // 是否无规格商品
        hide_stock: true, // 是否隐藏剩余库存
      },
      initialSku: {
        s1: 0,
        s2: 0,
        // 初始选中数量
        selectedNum: 0,
      },
      goods: {
        // 默认商品 sku 缩略图
        // picture: require("@/assets/img/mobile-img/yanxiuxueyuanlogo.png"),
        picture: "",
      },
      /* end--- vant sku 数据格式 --end */

      /* 商品会议详情数据 */
      // 会议基本信息
      articleMeeting: {},
      // 组委会信息
      committees: [],
      // 会议详情
      content: {},
      // 征稿采编
      edits: [],
      // 商品相关
      goodsDto: {},
      // 价格区间
      minPrice: null,
      maxPrice: null,
      // 举办单位总列表（主办2承办3协办1）
      organizerList: [],
      // 对单位列表处理，单独存储主办列表，承办列表和协办单位列表
      // 协办 type 1
      coOrganizerList: [],
      // 承办 type 3
      undertakerList: [],
      // 主办 type 2
      primaryOrgnizerList: [],
      // 合作期刊列表
      periodicals: [],
      // 会议资料
      fileList: [],
      // 会议相册
      imgVideoList: [],
      // 相关会议
      otherMeetingList: [],
      // 是否收藏 0已收藏 1未收藏
      isCollect: 1,
      // 当前会议是否可参加 0不可用 1可用
      isAvailable: 0,
      // 当前登录人是否已报名参加当前会议 0未参加 1已参加
      isUserExist: 0,
      // REGISTER_START-报名，REGISTER_OVER-报名截止，MEETING_OVER-会议结束
      meetingStatus: "",
      // 会议成员表
      memberList: [],
      shareInfo: {},
      // 商家详情
      business: {},

      // 如果当前详情接口返回指定code,标识下架
      isShelves: false,

      // 海报overlay
      showPoster: false,
      posterUrl: "",
      qrcode: null,
      // 海报模板中标题数据（如果涉及文本省略号，需JS处理，否则htmltocanvas无法显示省略号
      tempTitle: "",
      // 是否显示价格模块
      showPriceInfo: null,
      hasExtend: false,
      isSale: 0, // 是否停售 0 未停售，1 已停售
      contentList: [], // 会议详情自定义模块
      paperList: [],
      isPay: false, // 是否显示继续报名按钮
      isOnline: false, // 是否显示进入会议按钮（线上会议）
      contributeShow: false, // 投稿弹窗
      contributeUrl: "",
    };
  },
  filters: {
    meetingStatusFilter(status) {
      switch (status) {
        case "REGISTER_OVER":
          return "已截止";
        case "MEETING_OVER":
          return "已结束";
        case "REGISTER_NOT":
          return "未开始";
      }
    },
    tabsBgImgFilter(index) {
      let listIndex = index % 6;
      let bgImgClassList = [
        "item-bc-img1",
        "item-bc-img2",
        "item-bc-img3",
        "item-bc-img4",
        "item-bc-img5",
        "item-bc-img6",
      ];
      return `item-box ${bgImgClassList[listIndex]}`;
    },
  },
  computed: {
    goodsMinPrice() {
      if (this.maxPrice == 0 && this.minPrice == 0) {
        return "免费";
      } else {
        return this.maxPrice && this.maxPrice !== this.minPrice
          ? Number(this.minPrice).toFixed(2) + " - "
          : Number(this.minPrice).toFixed(2) + "";
      }
    },
    goodsMaxPrice() {
      return Number(this.maxPrice).toFixed(2) + "";
    },
    beginTime() {
      var dateStr =
        this.articleMeeting.beginTime &&
        this.articleMeeting.beginTime.replace(/-/g, "/");
      return this.articleMeeting.endTime
        ? this.$global.formatDateWithZh(dateStr, true) + " - "
        : this.$global.formatDateWithZh(dateStr, true);
    },
    endTime() {
      var dateStr = this.articleMeeting.endTime;
      dateStr = dateStr && dateStr.replace(/-/g, "/");
      return this.$global.formatDateWithZh(dateStr, true);
    },
    // 完整地址
    fullAddress() {
      return `${this.articleMeeting.province || ""} ${
        this.articleMeeting.city || ""
      } ${this.articleMeeting.address || ""}`;
    },
    // 合作期刊
    cooperativePeridicalNames() {
      var perNames = this.periodicals.map((item) => {
        return item.perName;
      });
      return perNames.join("，");
    },
    // 征稿日期
    editBeginTime() {
      return this.articleMeeting.editEndTime
        ? this.$global.formatDateWithZh(
            this.articleMeeting.editBeginTime,
            false
          ) + " - "
        : this.$global.formatDateWithZh(
            this.articleMeeting.editBeginTime,
            false
          );
    },
    editEndTime() {
      return this.$global.formatDateWithZh(
        this.articleMeeting.editEndTime,
        false
      );
    },
    // 相关会议的开始及结束时间
    relatedMeetingTime() {
      return function (startTime, endTime) {
        if (startTime && endTime) {
          return (
            this.$global.formatDateWithZh(startTime, false) +
            " - " +
            this.$global.formatDateWithZh(endTime, false)
          );
        } else {
          return startTime
            ? this.$global.formatDateWithZh(startTime, true)
            : this.$global.formatDateWithZh(endTime, true);
        }
      };
    },
    //报名按钮是否展示
    isShowSignupButton() {
      return !this.isAvailable != 1;
    },
  },
  created() {
    this.contributeUrl =
      this.$global.SeoUrl +
      `/detail/conference?id=${this.$route.query.id}&goodsId=${this.$route.query.goodsId}&open=1&type=8`;
    // 获取会议详情
    this.meetingDetails();
    this.getPaperList();
  },
  methods: {
    // 取消会议详情页顶部H5端打开APP头部 -----------
    eliminate() {
      // 分享 复制链接剔除特殊字段
      let url = document.location.toString();
      let urlArr = url.split("?");
      let baseUrl = urlArr[0] + "?";
      let params = Object.create(null);
      if (urlArr.length > 1) {
        urlArr = urlArr[1].split("&");
        urlArr.forEach((item) => {
          item = item.split("=");
          if (
            item[0] === "out" ||
            item[0] === "app" ||
            item[0] === "share" ||
            item[0] === "token"
          ) {
            return;
          }
          {
            params[item[0]] = item[1];
          }
        });
      }
      for (const key in params) {
        baseUrl = baseUrl + [key] + "=" + params[key] + "&";
      }
      return baseUrl;
    },
    toSearch() {
      if (this.$global.isAndroid_ios()) {
        window.android.openSearch();
      } else {
        window.webkit.messageHandlers.openSearch.postMessage("");
      }
    },
    // 右侧按钮((sharing为协商的方法名))
    rightBut() {
      let Url = this.eliminate();
      let sharInfo = {
        ...this.shareInfo,
        isCollect: sessionStorage.getItem("isCollect")
          ? sessionStorage.getItem("isCollect")
          : "",
        pageUrl: Url + "share=false",
        shareBox: "top",
      };
      console.log(sharInfo);
      const shareJson = JSON.stringify(sharInfo);
      if (this.$global.isAndroid_ios()) {
        window.android.sharing(shareJson);
      } else {
        window.webkit.messageHandlers.sharing.postMessage(shareJson); //ios
      }
    },
    // 取消会议详情页顶部H5端打开APP头部 -------------------------

    // 获取会议详情
    meetingDetails() {
      const _this = this;
      if (
        _this.$route.query.goodsId &&
        _this.$route.query.goodsId !== "null" &&
        _this.$route.query.open &&
        _this.$route.query.open != "0"
      ) {
        // 有商品id，调商品详情 isFrontEnd
        _this.$apis.goodsServe
          .meetingDetailsByGoodsId({
            goodsId: _this.$route.query.goodsId,
            frontEnd: 1,
          })
          .then((res) => {
            if (res.resultCode == 200) {
              document.title = res.data.articleMeeting.title;
              Object.keys(res.data).forEach((value) => {
                if (_this.hasOwnProperty(value)) {
                  _this[value] = res.data[value];
                }
              });
              // 处理旧数据，过滤期刊列表空数据
              _this.periodicals = _this.periodicals.filter((item) => {
                return item.perId != "" && item.perName != "";
              });
              // 单位地址分类
              _this.organizerList.forEach((item) => {
                if (item.type == 1) {
                  // 协办单位
                  _this.coOrganizerList.push(item);
                } else if (item.type == 2) {
                  // 主办单位
                  _this.primaryOrgnizerList.push(item);
                } else {
                  // 承办
                  _this.undertakerList.push(item);
                }
              });
              _this.showPriceInfo = true;
              // 海报单行显示标题，htmltocanvas手动处理文本溢出省略号，暂时固定单行15个字显示
              _this.tempTitle =
                res.data.articleMeeting.title.length > 15
                  ? res.data.articleMeeting.title.substring(0, 16) + "..."
                  : res.data.articleMeeting.title;
              // 获取推荐
              _this.getUser();
              // 处理自定义会议详情模块
              if (res.data.contentList) {
                _this.contentList = res.data.contentList.filter(
                  (item) => item.articleContent
                );
                let arr = _this.contentList.map((item) => {
                  return {
                    anchorName: item.contentFlag,
                    active: false,
                    show: true,
                  };
                });
                _this.tabsTitleTem = [..._this.tabsTitleTem, ...arr];
                // 根据各模块有无内容，决定是否显示顶部锚点导航项
                _this.updateTabsList();
              }
              // 微信分享内容
              _this.$global.toShare(
                res.data.articleMeeting.title,
                res.data.articleMeeting.artSummary,
                res.data.articleMeeting.cover
              );
              // 给APP分享需要的内容
              _this.shareInfo = {
                title: res.data.articleMeeting.title,
                cover: res.data.articleMeeting.cover,
                artSummary: res.data.articleMeeting.artSummary,
                articleId: _this.$route.query.id,
                articleType: _this.$route.query.type,
                open: _this.$route.query.open,
                saleType: 0,
              };
              if (res.data.goodsDto) {
                let indicativePriceList = []; // 参考价格 (页面展示价格)
                let skuPriceList = []; // 实际价格
                res.data.goodsDto.goodsSkuInfosDto.list.forEach((pItem) => {
                  if (pItem.indicativePrice || pItem.indicativePrice == 0)
                    indicativePriceList.push(Number(pItem.indicativePrice));
                  if (pItem.skuPrice || pItem.skuPrice == 0)
                    skuPriceList.push(Number(pItem.skuPrice));
                });
                if (indicativePriceList.length) {
                  indicativePriceList = [...new Set(indicativePriceList)]; // 去重
                  indicativePriceList = indicativePriceList.sort(
                    (a, b) => a - b
                  ); // 排序
                  _this.minPrice = indicativePriceList[0];
                  _this.maxPrice =
                    indicativePriceList[indicativePriceList.length - 1];
                } else {
                  skuPriceList = [...new Set(skuPriceList)]; // 去重
                  skuPriceList = skuPriceList.sort((a, b) => a - b); // 排序
                  _this.minPrice = skuPriceList[0];
                  _this.maxPrice = skuPriceList[skuPriceList.length - 1];
                }
                _this.shareInfo = {
                  ..._this.shareInfo,
                  goodsId: _this.$route.query.goodsId,
                  goodsTypeId: res.data.goodsDto.goods.goodsTypeId,
                  price:
                    _this.minPrice == _this.maxPrice
                      ? `${_this.minPrice}`
                      : `${_this.minPrice}-${_this.maxPrice}`,
                  saleType: res.data.saleType,
                };
                var skuDataObj = _this.$global.formatGoodsDataToVantSku(
                  _this.goodsDto,
                  _this.minPrice,
                  _this.maxPrice
                );
                console.log(skuDataObj, "skuDataObj");
                _this.sku = skuDataObj.sku;
                _this.goods = skuDataObj.goods;
                _this.initialSku = skuDataObj.initialSku;
                _this.isSale = res.data.goodsDto.isSale;
                // 文章是否为可推广文章
                _this.hasExtend =
                  res.data.goodsDto.goods.isPromotionGoods === 1;
              }
              _this.isPay = res.data.pay;
              _this.isOnline = res.data.goodsDto.goods.virtualGoods === 1;
            } else if (
              res.resultCode === "10401002" ||
              res.resultCode === "10401001"
            ) {
              this.isShelves = true;
            } else {
              this.$toast(res.resultDesc);
            }
          });
      } else {
        // 没有商品id,调普通会议详情
        _this.$apis.goodsServe
          .meetingDetailsById({ meetingId: _this.$route.query.id })
          .then((res) => {
            if (res.resultCode == 200) {
              Object.keys(res.data).forEach((value) => {
                if (_this.hasOwnProperty(value)) {
                  _this[value] = res.data[value];
                }
              });
              // 根据各模块有无内容，决定是否显示顶部锚点导航项
              _this.updateTabsList();

              // 单位地址分类
              _this.organizerList.forEach((item) => {
                if (item.type == 1) {
                  // 协办单位
                  _this.coOrganizerList.push(item);
                } else if (item.type == 2) {
                  // 主办单位
                  _this.primaryOrgnizerList.push(item);
                } else {
                  // 承办
                  _this.undertakerList.push(item);
                }
              });
              _this.showPriceInfo = false;

              document.title = res.data.articleMeeting.title;
              // 海报单行显示标题，htmltocanvas手动处理文本溢出省略号，暂时固定单行15个字显示
              _this.tempTitle =
                res.data.articleMeeting.title.length > 15
                  ? res.data.articleMeeting.title.substring(0, 16) + "..."
                  : res.data.articleMeeting.title;
              _this.getUser();

              // 给APP分享需要的内容
              _this.shareInfo = {
                title: res.data.articleMeeting.title,
                cover: res.data.articleMeeting.cover,
                artSummary: res.data.articleMeeting.artSummary,
                articleId: _this.$route.query.id,
                articleType: _this.$route.query.type,
                open: _this.$route.query.open,
                price: "免费",
                saleType: 0,
              };
              // 微信分享内容
              _this.$global.toShare(
                res.data.articleMeeting.title,
                res.data.articleMeeting.artSummary,
                res.data.articleMeeting.cover
              );
              // 文章是否为可推广文章
              _this.hasExtend = res.data.goodsDto.goods.isPromotionGoods === 1;
            } else if (
              res.resultCode === "10401002" ||
              res.resultCode === "10401001"
            ) {
              this.isShelves = true;
            } else {
              _this.$toast(res.resultDesc);
            }
          });
      }
    },
    updateTabsList() {
      // 根据各模块有无内容，决定是否显示顶部锚点导航项
      if (this.content.articleContent) this.tabsTitleTem[0].show = true;
      if (this.articleMeeting.isSubmit) this.tabsTitleTem[1].show = true;
      if (this.paperList.length) this.tabsTitleTem[2].show = true;
      if (this.committees.length) this.tabsTitleTem[3].show = true;
      if (this.fileList.length) this.tabsTitleTem[4].show = true;
      if (this.imgVideoList.length) this.tabsTitleTem[5].show = true;
      this.tabsTitle = this.tabsTitleTem.filter((item) => {
        return item.show == true;
      });
    },
    // 采编名片跳转名片详情
    toEditCard(editId, perId) {
      if (this.$route.query.out) {
        // 有out代表是APP进入
        if (this.$global.isAndroid_ios()) {
          //android
          window.open(
            `${this.$global.editCardUrl}?editId=${editId}&perId=${perId}`,
            "_blank"
          );
        } else {
          //ios
          window.location.href = `${this.$global.editCardUrl}?editId=${editId}&perId=${perId}`;
        }
      } else {
        window.open(
          `${this.$global.editCardUrl}?editId=${editId}&perId=${perId}`,
          "_blank"
        );
      }
    },
    // 组委会跳转百家
    scholarDetail(scholarId) {
      console.log(scholarId);
      if (scholarId == "" || scholarId == null || scholarId == undefined)
        return;
      let out = this.$route.query.out;
      out
        ? this.$router.push(`/appusesbaijia?item=0&id=${scholarId}&out=${out}`)
        : this.$router.push(`/appusesbaijia?item=0&id=${scholarId}`);
    },
    // 下载会议资料
    async downloadFile(url, name) {
      if (this.$route.query.out) {
        if (this.$global.isAndroid_ios()) {
          window.android.downloadUrl(
            this.$apis.mainServe.downloads +
              "?fileUrl=" +
              url +
              "&fileName=" +
              name
          );
        } else {
          window.webkit.messageHandlers.downloadUrl.postMessage(
            this.$apis.mainServe.downloads +
              "?fileUrl=" +
              url +
              "&fileName=" +
              name
          ); //ios
        }
      } else {
        // H5下载
        window.open(
          this.$apis.mainServe.downloads +
            "?fileUrl=" +
            url +
            "&fileName=" +
            name
        );
      }
    },
    // 更新sku弹窗的显示状态
    updateSkuPannelStatus(status) {
      this.showSku = status;
    },
    // 底部收藏和分享栏中显示的报名按钮，点击之后显示sku面板
    meetingSignup() {
      // 判断当前用户是否登录，
      this.$preventFun.Debounce(() => {
        if (sessionStorage.getItem("token")) {
          this.showSku = true;
        } else {
          if (this.$route.query.out) {
            if (this.$global.isAndroid_ios()) {
              window.android.getToken();
            } else {
              window.webkit.messageHandlers.getToken.postMessage("null"); //ios
            }
          } else {
            // 如果未登录，跳转登录页
            // 记录源网页，登录成功之后跳转回当前页面
            this.$router.push("/logins");
          }
        }
      })();
    },
    // sku选择商品规格之后 点击报名 skuCombData
    handleSignup(skuData) {
      console.log(skuData);
      var params = {};
      params.meetingId = this.articleMeeting.id;
      params.goodsId = this.articleMeeting.goodsId; // 商品会议id
      params.meetingTitle = this.articleMeeting.title;
      params.pictureUrl = skuData.pictureUrl;
      params.selectedNum = skuData.selectedNum;
      params.selectedText = skuData.selectedText;
      params.skuName =
        this.goodsDto.goodsSkuInfosDto.specificationsTypeValuesDtos.length > 0
          ? skuData.selectedText.replace("已选： ", "")
          : "";
      // skuData中selectedSkuComb对象数据扁平化
      params.price = (skuData.selectedSkuComb.price / 100).toFixed(2);
      params.skuPrice = skuData.selectedSkuComb.skuPrice;
      params.desc = skuData.selectedSkuComb.desc;
      params.skuId = skuData.selectedSkuComb.id; // 规格id
      params.stock_num = skuData.selectedSkuComb.stock_num;
      params.isExamine = skuData.selectedSkuComb.isExamine; // 是否需要审核
      params.shopsName = this.goodsDto.shopsInfoDto.shopsName; // 商户名称
      params.isRefund = this.goodsDto.goods.isRefund;
      if (this.$route.query.promoterId) {
        params.promoterId = this.$route.query.promoterId; // 推广Id
      }
      if (this.$route.query.out) {
        params.fromApp = true;
      }
      console.log("会议详情获取商品规格L:", params);
      // 扁平化所需数据之后存储至localStorage (避免页面下一级页面刷新导致数据丢失)
      sessionStorage.setItem("skuData", JSON.stringify(params));
      // 进入填写报名信息页面
      this.$router.push({ name: "fillPaticipantInfo" });
    },
    // 获取作者
    getUser() {
      this.$apis.recomendServe
        .getAuthor({
          type: this.articleMeeting.userType,
          userId: this.articleMeeting.createUser,
          companyId: this.articleMeeting.companyId
            ? this.articleMeeting.companyId
            : "",
        })
        .then((res) => {
          this.business = res.content;
          // console.log(res);
        });
    },
    // 跳转学者 期刊
    jump() {
      let out = this.$route.query.out;
      if (this.articleMeeting.userType === 2) {
        this.$router.push({
          path: "/appusesjigou",
          query: {
            item: 2,
            id: this.articleMeeting.companyId,
            out,
          },
        });
      } else if (this.articleMeeting.userType === 1) {
        this.$router.push({
          path: "/appusesbaike",
          query: {
            item: 1,
            id: this.articleMeeting.companyId,
            out,
          },
        });
      }
    },
    /* 海报内容相关 */
    // 海报分享
    sharePoster(showStatus, isExtend = false) {
      this.showPoster = showStatus;
      if (showStatus) {
        this.$nextTick(() => {
          this.drawPoster(isExtend);
        });
      }
    },
    // 二维码
    createQrCode(isExtend) {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      // 清空二维码,创建新的二维码
      this.qrcode = null;
      this.$refs["qrcode"].innerHTML = "";
      let text = `${location.href}${
        isExtend ? "&promoterId=" + userInfo.promoterId : ""
      }`;
      this.qrcode = new QRCode(document.getElementById("qrcode"), {
        width: 55 * 3,
        height: 55 * 3,
        text,
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    // html to canvas
    drawPoster(isExtend) {
      const _this = this;
      _this.createQrCode(isExtend);
      let scale = window.devicePixelRatio;
      html2canvas(document.querySelector("#poster-dom"), {
        useCORS: true,
        scrollY: 0,
        scrollX: 0,
        // width: 315,
        // height: 356,
        x: 0,
        y: 0,
        backgroundColor: "transparent",
        scale: scale ? scale : 1,
        windowWidth: Window.innerWidth,
        windowHeight: Window.innerHeight,
      }).then(function (canvas) {
        _this.posterUrl = canvas.toDataURL("image/png");
      });
    },
    // 关闭海报遮罩
    restorePageScroll() {
      this.showPoster = false;
      // 回到页面内，页面顶部导航栏状态恢复
      setTimeout(() => {
        this.$bus.$emit("posterVisibleStatus", this.showPoster);
      }, 500);
    },
    // 立即观看
    handleWatch() {
      window.open(this.articleMeeting.address, "_blank");
    },
    // 会议论文集列表
    async getPaperList() {
      let { data, resultCode } =
        await this.$apis.goodsServe.getMeetingDetailPaperList({
          id: this.$route.query.id,
          pageNo: 1,
          pageSize: 3,
        });
      if (resultCode === "200") {
        this.paperList = data.list;
        // 根据各模块有无内容，决定是否显示顶部锚点导航项
        this.updateTabsList();
      }
    },
    // 跳转会议论文集
    tocollectedPapers() {
      let out = this.$route.query.out;
      if (out) {
        this.$router.push({
          path: "/conferenceProceedings",
          query: {
            bid: this.$route.query.id,
            out,
          },
        });
      } else {
        this.$router.push({
          path: "/conferenceProceedings",
          query: {
            bid: this.$route.query.id,
          },
        });
      }
    },
    // 会议论文详情
    goConferencePaperDetails(id) {
      let out = this.$route.query.out;
      if (out) {
        this.$router.push({
          path: "/thesisDetail",
          query: {
            id,
            out,
            type: 0,
          },
        });
      } else {
        this.$router.push({
          path: "/thesisDetail",
          query: {
            id,
            type: 0,
          },
        });
      }
    },
    handleToBk(info) {
      this.$router.push({
        path: "/appusesbaike",
        query: {
          item: 1,
          id: info.perId,
        },
      });
    },
    // 投稿弹窗
    toContribute() {
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      input.setAttribute("value", this.contributeUrl);
      document.body.appendChild(input);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      document.body.removeChild(input);
      Toast("链接已复制");
      this.contributeShow = false;
    },
    // 页面内锚点跳转
    goAnchor(index) {
      // this.tabsTitle.map((item) => (item.active = false));
      // this.tabsTitle[index].active = true;
      var currentElem = document.querySelector(
        `[name=${this.tabsTitle[index].anchorName}]`
      );
      var contentOffsetTop = document.querySelector(".content").offsetTop;
      let top = Math.abs(contentOffsetTop + currentElem.offsetTop - 40);
      window.scrollTo({ top });
    },
    // 前往我的订单/会议
    toMy(type) {
      // 判断当前用户是否登录，
      this.$preventFun.Debounce(() => {
        if (sessionStorage.getItem("token")) {
          if (type === "meeting") {
            this.$router.push("mymeeting");
          } else {
            this.$router.push("orders");
          }
        } else {
          if (this.$route.query.out) {
            if (this.$global.isAndroid_ios()) {
              window.android.getToken();
            } else {
              window.webkit.messageHandlers.getToken.postMessage("null"); //ios
            }
          } else {
            // 如果未登录，跳转登录页
            // 记录源网页，登录成功之后跳转回当前页面
            this.$router.push("/logins");
          }
        }
      })();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .search-icon {
  margin-right: 20px;
  width: 20px;
  height: 20px;
}
@import "~@/assets/styles/public.scss";

#meeting-details {
  position: relative;
  z-index: 99;
  background: #f5f5f5;
  // 底部分享栏固定在窗口底部
  // padding-bottom: 50px;
  // padding-top: 44px;
  min-height: 100vh;

  // 下架样式
  .shelves-box {
    height: calc(100vh - 61px);
  }

  // 1.顶部图片
  .top-img {
    width: 100%;
    height: 211px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  // 2.主体内容区域
  .content {
    padding: 12px;
    width: 100%;

    // 各个内容分区通用样式
    .content-box {
      padding: 12px;
      margin-bottom: 12px;
      background: #fff;
      border-radius: 8px;

      //   各个内容分区顶部名称字体样式
      h1 {
        font-size: 17px;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
      }
    }
    .tabs-box {
      display: flex;
      flex-wrap: wrap;
      .tabs-item {
        margin-top: 8px;
        width: 50%;
        &:first-child,
        &:nth-child(2) {
          margin-top: 0;
        }
        &:nth-child(2n + 1) {
          padding-right: 4px;
        }
        &:nth-child(2n) {
          padding-left: 4px;
        }
        .item-box {
          height: 60px;
          line-height: 60px;
          text-align: center;
          border-radius: 6px;
          font-size: 15px;
          color: #333333;
          font-weight: 700;
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .item-bc-img1 {
          background-image: url("~@/assets/img/mobile-img/meeting-detail/bImg1.png");
        }
        .item-bc-img2 {
          background-image: url("~@/assets/img/mobile-img/meeting-detail/bImg2.png");
        }
        .item-bc-img3 {
          background-image: url("~@/assets/img/mobile-img/meeting-detail/bImg3.png");
        }
        .item-bc-img4 {
          background-image: url("~@/assets/img/mobile-img/meeting-detail/bImg4.png");
        }
        .item-bc-img5 {
          background-image: url("~@/assets/img/mobile-img/meeting-detail/bImg5.png");
        }
        .item-bc-img6 {
          background-image: url("~@/assets/img/mobile-img/meeting-detail/bImg6.png");
        }
      }
    }

    // 2.1 会议基本信息
    .meeting-info {
      .price {
        font-size: 16px;
        color: #ff3d3d;
        line-height: 17px;
      }

      .title {
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
        margin: 12px 0;
        // 会议标题修改完整显示
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
      }

      .time,
      .address {
        margin-top: 12px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #999999;

        img {
          width: 13px;
          height: 13px;
          margin-right: 10px;
        }
      }

      .address {
        img {
          width: 11px;
          height: 15px;
          margin-right: 11px;
        }
      }
    }

    // 2.1.1 会议单位
    .meeting-units {
      div {
        margin-bottom: 15px;
      }

      h1 {
        // margin-bottom: 15px;
      }

      p {
        margin-top: 12px;
      }
    }

    // 2.2 会议详情
    .detail-info {
      &::v-deep .detail-info-box {
        border-radius: 6px;
        margin-top: 16px;
        // 处理富文本编辑器中添加表格之类的内容，浮动显示影响布局
        overflow: hidden;

        img,
        video {
          max-width: 100% !important;
          height: auto !important;
        }

        // height: 437px;
        // background: #d8d8d8;
      }
    }

    // 2.3 征稿信息
    .call-for-papers {
      h3 {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        line-height: 23px;
        margin-top: 20px;
        margin-bottom: 10px;
      }

      // 采编名片
      .edit-infos {
        width: 100%;
        height: 177px;
        background: linear-gradient(360deg, #e9f1ff 0%, #f6f9ff 100%);
        border-radius: 6px;
        margin-bottom: 12px;

        h2 {
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          height: 23px;
          line-height: 23px;
          padding: 14px 21px 12px 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 49px;

          border-bottom: 1px solid #d8e4fd;

          p {
            width: 80%;
            overflow: hidden;
            text-overflow: ellipsis;
            flex-shrink: 0;
          }

          img {
            width: 5px;
            height: 9px;
            flex-shrink: 0;
          }
        }

        .edit-contact-info {
          padding: 15px;

          img {
            float: left;
            margin-right: 15px;
            width: 70px;
            height: 99px;
            border-radius: 3px;
          }

          h4 {
            line-height: 23px;
            margin-bottom: 20px;

            .edit-name {
              font-size: 16px;

              font-weight: 500;
              color: #333333;
              margin-right: 9px;
            }

            .edit-title {
              padding: 2px 5px;
              font-weight: 400;
              line-height: 15px;
              font-size: 11px;

              color: #fff;
              background: #4a79f1;
              border-radius: 3px;
            }
          }

          p {
            font-size: 13px;
            color: #666666;
            margin-top: 10px;
            line-height: 19px;
          }
        }
      }

      .edit-infos:last-child {
        margin-bottom: 0;
      }

      // 合作期刊和征稿日期
      .solicitation-date {
        display: flex;
        justify-content: flex-start;
        align-content: flex-start;
        margin-top: 20px;
        font-size: 14px;
        color: #333333;
        line-height: 23px;

        label {
          font-weight: 500;
          margin-right: 20px;
          flex-shrink: 0;
          width: 60px;
        }

        span,
        div {
          font-weight: 400;
          line-height: 20px;
        }
      }

      .cooperative-journal {
        .cooperative-journal-name {
          display: flex;
          overflow-x: auto;
          width: 100%;
          gap: 30px;
          padding-bottom: 10px;
          img {
            width: 80px;
            height: 113px;
            border-radius: 4px;
          }
          span {
            width: 80px;
            word-break: break-all;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }
      }

      // 征稿主题（富文本回显）
      .solicitation-theme {
        .solicit-content {
          // 处理表格回显浮动溢出
          overflow: hidden;

          // 处理富文本嵌套图片和视频回显尺寸
          img,
          video {
            width: 100%;
          }
        }

        p {
          margin-top: 15px;
        }
      }
    }
    // 2.9 会议论文
    .proceedingsList-info {
      .titleBox {
        display: flex;
        justify-content: space-between;
        h1 {
          font-weight: 500;
        }
        .genduo {
          font-weight: 400;
          font-size: 13px;
          color: #999999;
        }
      }

      .proceedingsList-item {
        margin-top: 15px;
        padding-bottom: 15px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        &:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }

        .title {
          font-weight: 500;
          font-size: 16px;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .author {
          margin-top: 15px;
          font-size: 13px;
          color: #999999;
        }
      }
    }

    // 2.4 组委会信息
    .committee-info {
      .committee-member {
        margin-top: 20px;

        .member-basic-info {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          img {
            width: 45px;
            height: 45px;
            border-radius: 50%;
            margin-right: 12px;
          }

          .member-name {
            font-size: 15px;
            font-weight: 500;
            color: #333333;
            line-height: 21px;
            margin-right: 12px;
          }

          .member-title {
            background: rgba(74, 121, 241, 0.1);
            border-radius: 3px;
            font-size: 12px;
            color: #4a79f1;
            line-height: 20px;
            padding: 2px 9px;
            margin-right: 8px;
          }

          .member-education-info {
            color: #999999;
            line-height: 19px;
            font-size: 13px;
            margin-top: 10px;
          }
        }

        .member-intro {
          margin-top: 12px;
          width: 100%;
          max-height: 70px;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          color: #333333;
          line-height: 23px;
          // -webkit-line-clamp CSS 属性可以把块容器中的内容限制为指定的行数。只有在 display 属性设置成 -webkit-box 或者 -webkit-inline-box 并且 box-orient 属性设置成 vertical时才有效果
          -webkit-line-clamp: 3;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
      }
    }

    // 2.5 会议资料
    .conference-proceedings {
      li {
        margin-top: 13px;

        a {
          font-size: 14px;
          color: #333333;
          line-height: 20px;
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
        }
      }
    }

    // 2.6 会议相册
    .album {
      .album-container {
        margin-top: 20px;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        overflow: auto;
        height: 133px;

        &::-webkit-scrollbar {
          display: none;
        }

        .album-item {
          width: 200px;
          height: 100%;
          margin-right: 12px;
          flex-shrink: 0;

          img {
            display: block;
            width: 200px;
            height: 133px;
            background: #d8d8d8;
            border-radius: 12px;
          }

          video {
            width: 100%;
            height: 100%;
          }
        }

        .album-item:only-child {
          width: 100%;
        }

        .album-item:last-child {
          margin-right: 0;
        }
      }
    }

    // 2.7 金融研修学院
    .college-of-finance {
      display: flex;
      align-items: center;
      height: 70px;

      img {
        width: 50px;
        height: 47px;
        border-radius: 50%;
      }

      .businessName {
        width: 210px;
        margin-left: 10px;
      }

      button {
        width: 60px;
        height: 30px;
        background: #4a79f1;
        border-radius: 15px;
        font-size: 14px;
        color: #fff;
        border: 0;
      }
    }

    // 2.8 相关会议
    .related-meetings {
      .related-meeting-card {
        margin-top: 12px;
        max-height: 261px;
        width: 100%;
        background: #ffffff;
        border-radius: 6px;
        border: 1px solid rgba(0, 0, 0, 0.1);

        img {
          width: 100%;
          height: 184px;
        }

        h2 {
          padding: 12px;

          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          line-height: 23px;
        }

        p {
          display: flex;
          justify-content: space-between;
          align-items: center;

          margin: 5px 12px;
          font-size: 12px;
          color: #999;
          line-height: 19px;

          span {
            flex-shrink: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          span:first-child {
            width: 100px;
          }

          span:last-child {
            // width: 180px;
          }
        }
      }
    }
  }

  ::v-deep .footer-toolbar {
    background: #ff3d3d !important;

    ::v-deep .signup-btn {
      width: 160px;
      height: 40px;
      background: #4a79f1 !important;
      border-radius: 20px;
      border: 0;
      font-size: 15px;
      font-weight: 500;
      color: #ffffff;
    }
  }

  .empty-data {
    text-align: center;

    .zanwu-img {
      width: 15%;
    }
  }
  ::v-deep .has-top {
    .showNav {
      top: calc(constant(safe-area-inset-top)) !important;
      top: calc(env(safe-area-inset-top)) !important;
    }
  }
  .suspended-box {
    position: fixed;
    right: 12px;
    bottom: 100px;
    .suspended-item {
      padding: 10px 8px;
      text-align: center;
      background: #ffffff;
      box-shadow: 0px 2px 6px 0px rgba(28, 63, 153, 0.15);
      border-radius: 50%;
      &:first-child {
        margin-bottom: 15px;
      }
      .suspended-img {
        width: 18px;
        height: 18px;
      }
      .suspended-title {
        font-size: 10px;
        color: #666666;
        line-height: 14px;
      }
    }
  }
}
.continue_box {
  position: absolute;
  top: -35px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  width: 100vw;
  height: 35px;
  background-color: #e9efff;
  color: #4a79f1;
  &::v-deep .van-button {
    width: 90px;
    height: 28px;
    background-color: #e9efff;
  }
}
.contribute_box {
  padding: 20px;
  width: 315px;
  h3 {
    text-align: center;
    font-size: 16px;
    color: #333333;
  }
  p {
    margin: 20px 0;
    font-size: 14px;
    color: #333333;
    line-height: 21px;
  }
  &::v-deep .van-button {
    width: 130px;
    height: 40px;
    &:last-child {
      margin-left: 15px;
    }
  }
}
</style>
<style lang="scss">
@import "~@/assets/styles/poster.scss";
</style>
